<template>
  <div class="nav-header">
    <div class="container">
      <!-- 左侧 -->
      <div class="n-l">
        <!-- logo -->
        <div class="logo">
          <img src="/imgs/logo.png" alt="" />
        </div>
        <!-- 导航列表 -->
        <div class="n-list">
          <a href="/">网站首页</a>
          <a href="/#/ac">纠纷处理</a>
          <a href="/#/agreement">用户协议</a>
          <a href="/#/jf">用户权益保障措施</a>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="n-r">
        <span class="n-login">
          <span @click="goLogin()" v-if="this.LoggedShow" class="n-lg" > 立即登录</span>
        </span>
        <!-- 用户名 -->
        <span class="n-info" v-show="!this.LoggedShow" v-text="this.nv_user.Username"
          ><i class="iconfont icon-denglu"></i
        ></span>
        <!-- 退出登录 -->
        <span class="n-info" @click="tolg()" v-show="!this.LoggedShow">
          <i class="iconfont icon-tuichudenglu"></i>
          退出登录
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    href: String,
  },
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      location.reload();
      // this.$forceUpdate()
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
@import "./../assets/scss/modal.scss";
.nav-header {
  width: 100%;
  height: 80px;
  background: #fff;
  border-bottom: 1px solid #ccc;
  position: sticky;
  top: 0;
  z-index: 20;
  .container {
    height: 100%;
    @include flex();
    // 左侧
    .n-l {
      width: 70%;
      height: 100%;
      display: flex;
      align-items: center;
      // logo
      .logo {
        width: 200px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .n-list {
        margin-left: 50px;

        a {
          font-size: 16px;
          margin: 0 20px;
          color: #a0a0a0;
          transition: all 0.3s;
          display: inline-block;
          &:nth-child(1) {
            color: #aed0ee;
          }
          &:hover {
            transform: translateY(-3px);
            color: #aed0ee;
          }
        }
      }
    }
    // 右侧
    .n-r {
      display: flex;
      align-items: center;
      .n-lg {
        width: 95px;
        height: 35px;
        background-color: #aed0ee;
        display: inline-block;
        text-align: center;
        line-height: 35px;
        border-radius: 20px;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          width: 110px;
        }
      }
      .n-info {
        font-size: 14px;
        color: #888;
        margin: 0 15px;
        cursor: pointer;
      }
    }
  }
}
</style>
